import { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function KundaliMatch() {
    const navigate = useNavigate();
    const [form, setForm] = useState({
        boyname: "",
        boydob: "",
        boytob: "",
        boyplace: "",
        girlname: "",
        girldob: "",
        girltob: "",
        girlplace: ""
    });

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        try {
            console.log("Kundali Input:", form);
            // Call API / navigate to kundali page
            navigate("/kundali-match-result", {
                state: {
                    boyname: form.boyname,
                    boydob: form.boydob,
                    boytob: form.boytob,
                    boyplace: form.boyplace,
                    girlname: form.girlname,
                    girldob: form.girldob,
                    girltob: form.girltob,
                    girlplace: form.girlplace
                }
            })
        } catch (error) {
            console.log("error ===>", error)
        }
    };

    return (
        <div style={styles.container}>
            <h1 style={styles.title}>Get Free Kundali</h1>
            <p style={styles.subtitle}>
                Enter your birth details to generate your Janma Kundali
            </p>

            <form style={styles.card} onSubmit={handleSubmit}>
                Boy Details
                <input
                    type="text"
                    name="boyname"
                    placeholder="Full Name"
                    value={form.boyname}
                    onChange={handleChange}
                    style={styles.input}
                    required
                />



                <input
                    type="date"
                    name="boydob"
                    value={form.boydob}
                    onChange={handleChange}
                    style={styles.input}
                    required
                />

                <input
                    type="time"
                    name="boytob"
                    value={form.boytob}
                    onChange={handleChange}
                    style={styles.input}
                    required
                />

                <input
                    type="text"
                    name="boyplace"
                    placeholder="Place of Birth"
                    value={form.boyplace}
                    onChange={handleChange}
                    style={styles.input}
                    required
                />



                Girl Details


                <input
                    type="text"
                    name="girlname"
                    placeholder="Full Name"
                    value={form.girlname}
                    onChange={handleChange}
                    style={styles.input}
                    required
                />



                <input
                    type="date"
                    name="girldob"
                    value={form.girldob}
                    onChange={handleChange}
                    style={styles.input}
                    required
                />

                <input
                    type="time"
                    name="girltob"
                    value={form.girltob}
                    onChange={handleChange}
                    style={styles.input}
                    required
                />

                <input
                    type="text"
                    name="girlplace"
                    placeholder="Place of Birth"
                    value={form.girlplace}
                    onChange={handleChange}
                    style={styles.input}
                    required
                />

                <button type="submit" style={styles.button}>
                    Generate Kundali
                </button>

            </form>
        </div>
    );
}



const styles = {
    container: {
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        paddingTop: "40px",
        width: "100%"
    },
    title: {
        fontSize: "32px",
        color: "#7c2d12"
    },
    subtitle: {
        color: "#92400e",
        marginBottom: "20px"
    },
    card: {
        background: "#ffffff",
        padding: "25px",
        borderRadius: "12px",
        width: "100%",
        maxWidth: "400px",
        boxShadow: "0 8px 20px rgba(0,0,0,0.1)",
        display: "flex",
        flexDirection: "column",
        gap: "12px"
    },
    input: {
        padding: "10px",
        fontSize: "14px",
        borderRadius: "6px",
        border: "1px solid #d1d5db"
    },
    button: {
        marginTop: "10px",
        padding: "12px",
        background: "#b45309",
        color: "#fff",
        border: "none",
        borderRadius: "8px",
        fontSize: "16px",
        cursor: "pointer"
    }
};